/**
 * <pdf-design-picker> — the gift-card PDF-design picker (D-20 phase 2b,
 * snippets/pdf-design-picker.liquid).
 *
 * Rebuild of live's legacy-prefixed picker element (the pdf-picker module
 * inside the legacy-prefixed custom-JS webpack bundle of the live
 * snapshot). Behavior ported 1:1:
 *
 *  - on connect, filter the server-rendered design list down to the selected
 *    variant and auto-select the first visible design (live filtered against
 *    its dropdown's initially-selected <option>; the server renders the same
 *    answer into data-selected-variant-id here);
 *  - a variant change re-filters and re-selects. Live listened for its own
 *    dropdown's document-level event carrying the variant TITLE and matched
 *    it against data-value; the rebuild's variant machinery is Dawn's, so
 *    this element subscribes to the variantChange pub/sub (the
 *    availability-gate pattern) and matches the event's variant id against
 *    data-variant-id — the same stored variant reference live's title match
 *    resolved, without depending on locale-formatted title strings;
 *  - selecting a design (auto or click) writes the design's PDF file URL
 *    into a hidden properties[...] input on the add-to-cart form, creating
 *    the input once before the form's first child — live's insert position.
 *    A variant with no matching designs hides every entry and leaves the
 *    last written property untouched, exactly live's behavior.
 *
 * The property KEY is a live cart data contract; it arrives via
 * data-property-key from the adapter ('pdf-design-property-key') and is
 * never spelled here (the free-gift-property-key precedent).
 *
 * R-01: no cart endpoint is touched and nothing here runs on page view
 * beyond DOM work — the only write is a form input the standard product
 * form submits.
 */
if (!customElements.get('pdf-design-picker')) {
  customElements.define(
    'pdf-design-picker',
    class PdfDesignPicker extends HTMLElement {
      connectedCallback() {
        this.designs = Array.from(this.querySelectorAll('li'));
        this.form = document.querySelector('form[data-type="add-to-cart-form"]');

        this.designs.forEach((design) => design.addEventListener('click', () => this.selectDesign(design)));

        this.filterDesigns(this.dataset.selectedVariantId);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            const variant = event && event.data ? event.data.variant : null;
            if (variant && variant.id) this.filterDesigns(String(variant.id));
          });
        }
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
      }

      filterDesigns(selectedVariantId) {
        if (!selectedVariantId) return;
        let firstVisibleDesign = null;
        this.designs.forEach((design) => {
          if (design.dataset.variantId !== selectedVariantId) {
            design.setAttribute('hidden', '');
          } else {
            design.removeAttribute('hidden');
            if (!firstVisibleDesign) firstVisibleDesign = design;
          }
        });
        if (firstVisibleDesign) this.selectDesign(firstVisibleDesign);
      }

      selectDesign(design) {
        this.designs.forEach((other) => other.classList.remove('selected'));
        design.classList.add('selected');

        if (!this.form) return;
        const propertyKey = this.dataset.propertyKey;
        if (!propertyKey) return;
        const dataHolder = design.querySelector('.pdf-design-picker__data');
        if (!dataHolder || !dataHolder.dataset.url) return;

        let input = this.form.querySelector(`input[name="properties[${propertyKey}]"]`);
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = `properties[${propertyKey}]`;
          this.form.insertBefore(input, this.form.firstChild);
        }
        input.value = dataHolder.dataset.url;
      }
    }
  );
}
